$(function() {
  if (window.location.pathname == '/contact/thank-you') {
    localStorage.removeItem('orderItems');
  }
  
  $('.popup-gallery').magnificPopup({
    delegate: 'a',
    type: 'image',
    tLoading: 'Loading image #%curr%...',
    mainClass: 'mfp-img-mobile',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
    },
    image: {
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      titleSrc: function(item) {
        return item.el.attr('title');
      }
    }
  });
  
  $('.popup-video').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
  
    fixedContentPos: false
  });
  
  function setStickTableHeader() {
    if ($(document).width() > 767) {
      $('.sticky-table-header').stickyTableHeaders();
    } else {
      $('.sticky-table-header').stickyTableHeaders('destroy');
    }
  }
  
  setStickTableHeader();
  
  $(window).resize(function() {
    setStickTableHeader();
  });
  
  const orderItems = JSON.parse(localStorage.getItem('orderItems'));
  let palletCountMultiplier = 'Stanard';
  let basketUnits = 0;
  let palletCountLightGlobal = 1;
  let palletCountStandardGlobal = 1;
  let palletCountHeavyGlobal = 1;
  
  // *************************************
  // Cart notification widget
  // **************************************
  
  function updateCartCount() {
    let orderItemsCount = JSON.parse(localStorage.getItem('orderItems'));
    orderItemsCount = orderItemsCount.length;
  
    if (orderItemsCount > 0) {
      $('.cart-link__total').text(orderItemsCount);
      if (window.location.pathname == '/wire-baskets/order') {
        return true;
      }
      if (orderItemsCount == 1) {
        $('.cart-link__text').text('item in order');
      } else {
        $('.cart-link__text').text('items in order');
      }
      $('.cart-link').show();
    }
  }
  
  // Run it on page load
  if (orderItems != null) {
    updateCartCount();
  }
  
  // *************************************
  // Product and Finder page
  // **************************************
  
  function resetOrderDialogFields() {
    // reset the fields
    $('.dialog #basket-categories').val('');
    $('.dialog #top-size').val('');
    $('.dialog #taper').val('');
    $('.dialog #grade').blur();
    $('.dialog #quantity').val(0);
    $('.dialog #burlap_type').blur();
    $('.dialog #burlap_treatment').blur();
    $('.dialog #burlap_grade').blur();
    $('.dialog #burlap_quantity').val(0);
    $('.dialog .burlap-type-container').remove();
    $('.dialog .basket-unit-count__data').text('');
    $('.dialog .burlap-unit-count__data').text('');
    console.log('form cleared');
  }
  
  function openAddtoOrderDialog({
    basketCategories,
    productCategory = 'basket',
    selectedBottomType,
    bottomTypes,
    topSize,
    taper,
    palletCountLight,
    palletCountStandard,
    palletCountHeavy,
    burlapLiner,
    burlapSquare
  }) {
    resetOrderDialogFields();
  
    if (productCategory == 'basket') {
      palletCountLightGlobal = palletCountLight;
      palletCountStandardGlobal = palletCountStandard;
      palletCountHeavyGlobal = palletCountHeavy;
  
      $('.dialog #basket-categories').val(basketCategories);
      $('.dialog #top-size').val(topSize);
      $('.dialog #taper').val(taper);
  
      let burlapOptions = `<option value="Unselected">Select Burlap Type</options>`;
      if (burlapLiner) {
        burlapOptions += `<option value="Liner ${burlapLiner}">Liner: ${burlapLiner}</option>`;
      }
      if (burlapSquare) {
        burlapOptions += `<option value="Square ${burlapSquare}">Square: ${burlapSquare}</option>`;
      }
      if (burlapLiner || burlapSquare) {
        $(`
                  <div class="my-1 burlap-type-container">
                      <div class="relative">
                          <select autocomplete="off" class="appearance-none px-1 py-1 bg-grey-200 text-center w-full" name="burlap_type" id="burlap_type">
                              ${burlapOptions}
                          </select>
                          <div class="pointer-events-none absolute pin-y pin-r flex items-center px-.5 text-grey-darker">
                              <svg class="fill-current h-1 w-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path></svg>
                          </div>
                      </div>
                  </div>
                  `).insertAfter('.burlap-options-heading');
      } else {
        $('.dialog #burlap_type').remove();
      }
  
      // add bottom types
      // bottom type has been selected externally
      if (selectedBottomType) {
        $('.dialog__inner--add-item').append(`<input id="bottom-type" type="hidden" name="bottom-type" value="${selectedBottomType}" >`);
        // we need to select a bottom type still
      } else {
        $('.bottom-type-container').remove(); // if there was one from before
        $(`
                  <div class="py-1 bottom-type-container">
                      <div class="relative">
                          <select autocomplete="off" class="appearance-none pl-1 py-1 pr-2 bg-grey-200 text-center w-full" name="bottom-type" id="bottom-type">
                              <option value="Unselected">Select Bottom Type</option>
                          </select>
                          <div class="pointer-events-none absolute pin-y pin-r flex items-center px-.5 text-grey-darker">
                                  <svg class="fill-current h-1 w-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                              </div>
                          </div>
                      </div>
                  </div>
              `).insertAfter('.dialog__title');
        for (let i = 0; i <= bottomTypes.length - 1; i++) {
          $('.dialog #bottom-type').append(`<option value="${bottomTypes[i]}">${bottomTypes[i]}</option>`);
        }
      }
  
      // Burlap product
    } else if (productCategory == 'burlap') {
      $('.dialog .basket-grade-container').hide();
      $('.dialog .basket-quantity-container').hide();
      $('.dialog #burlap').blur();
      $('.dialog__title').text('Burlap Options');
      $(`
          <div class="my-1 burlap-type-container">
              <div class="relative">
                  <select autocomplete="off" class="appearance-none px-1 py-1 bg-grey-200 text-center w-full" name="burlap_type" id="burlap_type">
                      <option value="Unselected">Select Burlap Type</options>
                      <option value="Liners">Liners</option>
                      <option value="Squares">Squares</option>
                  </select>
                  <div class="pointer-events-none absolute pin-y pin-r flex items-center px-.5 text-grey-darker">
                      <svg class="fill-current h-1 w-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path></svg>
                  </div>
              </div>
          </div>
          `).insertAfter('.burlap-options-heading');
      $('.burlap-options-heading ').hide();
    }
  
    $('.dialog').fadeIn(200);
  }
  
  function addItemToStorage({ productCategory = 'basket' }) {
    const orderItems = JSON.parse(localStorage.getItem('orderItems')) || [];
    const newItemId = orderItems.length + 1;
    let newItem = '';
  
    const burlap = $('.dialog #burlap').val();
    const burlapType = $('.dialog #burlap_type').val();
    const burlapTreatment = $('.dialog #burlap_treatment').val();
    const burlapGrade = $('.dialog #burlap_grade').val();
    const burlapQuantity = $('.dialog #burlap_quantity').val();
  
    if (productCategory == 'basket') {
      const basketCategory = $('.dialog #basket-categories').val();
      const topSize = $('.dialog #top-size').val();
      const taper = $('.dialog #taper').val();
      const bottomType = $('.dialog #bottom-type').val();
  
      const grade = $('.dialog #grade').val();
      const quantity = $('.dialog #quantity').val();
  
      newItem = {
        orderItem: {
          id: newItemId,
          productCategory,
          basketCategory,
          topSize,
          taper,
          bottomType,
          grade,
          burlap,
          quantity,
          basketUnits,
          burlapType,
          burlapTreatment,
          burlapGrade,
          burlapQuantity
        }
      };
    } else if (productCategory == 'burlap') {
      const burlap = $('.dialog #burlap').val();
      const quantity = $('.dialog #quantity').val();
  
      newItem = {
        orderItem: {
          id: newItemId,
          productCategory,
          burlap,
          burlapType,
          burlapTreatment,
          burlapGrade,
          burlapQuantity
        }
      };
    } else {
      return false;
    }
  
    orderItems.push(newItem);
  
    localStorage.setItem('orderItems', JSON.stringify(orderItems));
  
    showItemAddedConfirmation();
    updateCartCount();
  }
  
  function showItemAddedConfirmation() {
    $('.dialog__inner--add-item').fadeOut(300, function() {
      $('.dialog__inner--add-item-confirmation').show();
    });
  }
  
  function calculatePalletAmount() {
    switch ($('.dialog #grade').val()) {
      case 'Light Grade':
        palletCountMultiplier = palletCountLightGlobal;
        break;
      case 'Heavy Grade':
        palletCountMultiplier = palletCountHeavyGlobal;
        break;
      default:
        palletCountMultiplier = palletCountStandardGlobal;
    }
  
    basketUnits = palletCountMultiplier * $('.dialog #quantity').val();
    if (!basketUnits) {
      basketUnits = 'TBD';
    }
    if ($('.dialog #quantity').val() > 0) {
      $('.basket-unit-count').show();
      $('.basket-unit-count__data').text(basketUnits + ' pieces');
    } else {
      $('.basket-unit-count').hide();
    }
  }
  
  // Events
  
  $(document).on('keyup', function(e) {
    if (e.keyCode == 27) {
      $('.dialog').fadeOut(200);
    }
    return false;
  });
  
  $('.js-dialog-add-to-order-btn').on('click', function() {
    const productCategory = $(this).data('product-category');
    addItemToStorage({ productCategory: productCategory });
    $('.bottom-type-container').remove();
    $('.dialog__continue').fadeIn();
  });
  
  $('body').on('click', 'a.js-add-to-order-btn', function() {
    $('.dialog__inner--add-item').show();
    $('.dialog__inner--add-item-confirmation').hide();
  
    let selectedBottomType;
  
    if ($('.js-basket-finder-input-bottom-type.selected').length) {
      selectedBottomType = $('.js-basket-finder-input-bottom-type.selected').data('bottom-type');
    }
  
    let basketCategories;
  
    if ($(this).data('basket-categories')) {
      basketCategories = $(this).data('basket-categories');
    } else {
      basketCategories = $('.page-title').text(); // grabbing from the dom, how embarrassing.
    }
  
    let bottomTypes = $(this).data('bottom-types');
  
    bottomTypes = bottomTypes.split(',');
  
    openAddtoOrderDialog({
      basketCategories: basketCategories,
      bottomTypes: bottomTypes,
      burlapLiner: $(this).data('burlap-liner'),
      burlapSquare: $(this).data('burlap-square'),
      palletCountHeavy: $(this).data('pallet-count-heavy'),
      palletCountLight: $(this).data('pallet-count-light'),
      palletCountStandard: $(this).data('pallet-count-standard'),
      productCategory: 'basket',
      selectedBottomType: selectedBottomType,
      topSize: $(this).data('top-size'),
      taper: $(this).data('taper')
    });
    return false;
  });
  
  $('.js-dialog-close, .dialog__bg').on('click', function() {
    $('.dialog').fadeOut(200);
    return false;
  });
  
  $('.dialog__continue').on('click', function() {
    $('.dialog').fadeOut(200);
    return false;
  });
  
  $('.dialog #grade').on('change', function() {
    calculatePalletAmount();
  });
  
  $('.dialog #quantity').on('change', function() {
    calculatePalletAmount();
  });
  
  // *************************************
  // Burlap product page
  // **************************************
  
  $('.btn--burlap').on('click', function() {
    //open order dialog
    console.log('opening');
    openAddtoOrderDialog({
      productCategory: 'burlap',
      bottomTypes: undefined
    });
  });
  
  $('.dialog #burlap_quantity').on('change', function() {
    let units = $(this).val();
    units = '(' + units * 500 + ') pieces';
    $('.burlap-unit-count__data').text(units);
  });
  
  $('.js-run-basket-search').on('click', function(e) {
    e.preventDefault;
    resetOrderDialogFields();
    return false;
  });
  
  // *************************************
  // Submit order page
  // **************************************
  
  function printOrderItem(id) {
    let item = undefined;
  
    let burlapQuantity = orderItems[id].orderItem.burlapQuantity;
    let burlapType = orderItems[id].orderItem.burlapType == 'Unselected' ? 'Type not selected' : orderItems[id].orderItem.burlapType;
    let burlapTreatment = orderItems[id].orderItem.burlapTreatment == 'Unselected' ? 'Treatment not selected' : orderItems[id].orderItem.burlapTreatment;
    let burlapGrade = orderItems[id].orderItem.burlapGrade == 'Unselected' ? 'Grade not selected' : orderItems[id].orderItem.burlapGrade;
  
    item = `<li class="order-item text-md mb-1 p-1 lg:mb-2 lg:p-2 max-w-40 mx-auto bg-grey-200 text-left relative">`;
  
    if (orderItems[id].orderItem.productCategory == 'basket') {
      let palletsTerm = 'pallet';
  
      if (orderItems[id].orderItem.quantity > 1) {
        palletsTerm = 'pallets';
      }
  
      let taper = orderItems[id].orderItem.basketCategory.match(/°/) ? '' : ` ${orderItems[id].orderItem.taper}`;
  
      if (taper == ' Other') {
        taper = '';
      }
  
      let basketCategory = orderItems[id].orderItem.basketCategory;
      let basketCategorySlug = orderItems[id].orderItem.basketCategorySlug;
      let basketGrade = orderItems[id].orderItem.grade == 'Unselected' ? 'Grade not selected' : `• ${orderItems[id].orderItem.grade}`;
      let basketUnits = orderItems[id].orderItem.basketUnits;
      let bottomType = orderItems[id].orderItem.bottomType == 'Unselected' ? 'Bottom Type not selected' : `• ${orderItems[id].orderItem.bottomType} bottom`;
      let quantity = orderItems[id].orderItem.quantity;
      let topSize = orderItems[id].orderItem.topSize;
  
      item += `
          <div class="w-full text-h3 mb-.5">
              <div class="no-underline leading-none">
                  ${topSize}" ${basketCategory}${taper} Wire Basket
              </div>
          </div>
          <div class="uppercase">
              <span>${basketGrade}</span>
              <span class="inline-block ml-.5">${bottomType}</span>
          </div>
          <div class="py-.75 lg:py-1">
              <span class="text-md font-bold px-.5 py-.25 uppercase bg-grey-200">
                  ${quantity} ${palletsTerm}
                  <span class="text-sm">
                      (${basketUnits} units)
                  </span>
              </span>
          </div>
  
          <div class="border-t-2 border-b-2 border-grey-300 py-.5">
              <strong class="inline-block mr-.5">Burlap:</strong>
              <span class="inline-block mr-.5 white-space-no-wrap">${burlapQuantity} Bales</span>
              <span class="inline-block mr-.5 white-space-no-wrap">${burlapType}</span>
              <span class="inline-block mr-.5 white-space-no-wrap">${burlapTreatment}</span>
              <span class="inline-block mr-.5 white-space-no-wrap">${burlapGrade}</span>
          </div>
          `;
    } else if (orderItems[id].orderItem.productCategory == 'butlap' || orderItems[id].orderItem.productCategory == 'burlap') {
      item += `
          <div class="w-full text-h3 mb-.5">
              Burlap
          </div>
          <div>
              <span class="inline-block mr-.5 white-space-no-wrap">${burlapQuantity} Bales</span>
              <span class="inline-block mr-.5 white-space-no-wrap">${burlapType}</span>
              <span class="inline-block mr-.5 white-space-no-wrap">${burlapTreatment}</span>
              <span class="inline-block mr-.5 white-space-no-wrap">${burlapGrade}</span>
          </div>`;
    }
  
    item += `
          <div class="absolute pin-t pin-r pr-.5 lg:pt-.5 lg:pr-1">
              <a data-id="${orderItems[id].orderItem.id}" class="order-remove-item leading-none text-sm no-underline hover:underline uppercase" href="#">Remove</a>
          </div>
      </li>`;
  
    if ($('.order-list').length > 0) {
      $('.order-list').append(item);
    }
  
    updateCartCount();
  }
  
  // Populate our hidden products being ordered field
  function setOrderBasketFieldData() {
    const orderItems = JSON.parse(localStorage.getItem('orderItems'));
  
    if ($('#input-baskets_requested').length > 0) {
      let orderItemsString = '';
  
      for (var i = 0; i < orderItems.length; i++) {
        if (orderItems[i].orderItem.id) {
          if (orderItems[i].orderItem.productCategory == 'basket') {
            orderItemsString += `
                      Product: ${orderItems[i].orderItem.productCategory}
                      Basket: ${orderItems[i].orderItem.basketCategory}
                      Taper: ${orderItems[i].orderItem.taper}
                      Top Size: ${orderItems[i].orderItem.topSize}
                      Grade: ${orderItems[i].orderItem.grade}
                      Bottom type: ${orderItems[i].orderItem.bottomType}
                      Basket Quantity: ${orderItems[i].orderItem.quantity} Pallets (${orderItems[i].orderItem.basketUnits} units)
                      Burlap Type: ${orderItems[i].orderItem.burlapType}
                      Burlap Quantity: ${orderItems[i].orderItem.burlapQuantity}
                      Burlap Treatment: ${orderItems[i].orderItem.burlapTreatment}
                      Burlap Grade: ${orderItems[i].orderItem.burlapGrade}
              `;
          } else if (orderItems[i].orderItem.productCategory == 'burlap') {
            orderItemsString += `
                          Product: ${orderItems[i].orderItem.productCategory}
                          Burlap Type: ${orderItems[i].orderItem.burlapType}
                          Burlap Quantity: ${orderItems[i].orderItem.burlapQuantity}
                          Burlap Treatment: ${orderItems[i].orderItem.burlapTreatment}
                          Burlap Grade: ${orderItems[i].orderItem.burlapGrade}
                          `;
          } else {
            // do nothing
          }
        }
      }
  
      $('#input-baskets_requested').val(orderItemsString);
    }
  }
  
  // On page load, list the orders that are in local storage
  if ($('.order-list').length > 0) {
    if (orderItems.length > 0) {
      for (let i = 0; i < orderItems.length; i++) {
        printOrderItem(i);
      }
    } else {
      $('.order-list').html(`<p class="text-center">Your order is empty. Time to <a href="/wire-baskets">start shopping.</a></p>`);
    }
  
    setOrderBasketFieldData();
  }
  
  // Remove items from the order list
  $('.order-remove-item').on('click', function() {
    const removeId = $(this).data('id');
  
    localStorage.removeItem(`orderItems[${removeId}]`);
    $(this)
      .closest('li.order-item')
      .remove();
  
    let orderItems = JSON.parse(localStorage.getItem('orderItems'));
  
    orderItems = orderItems.filter(function(obj) {
      return obj.orderItem.id !== removeId;
    });
  
    localStorage.setItem('orderItems', JSON.stringify(orderItems));
  
    if (orderItems.length < 1) {
      $('.order-list').html(`<p class="text-center">Your order is empty. Time to <a href="/wire-baskets">start shopping.</a></p>`);
    }
  
    setOrderBasketFieldData();
    updateCartCount();
  
    return false;
  });
  
  let degrees = '';
  let topSize = '';
  let bottomType = '';
  
  function slugify(string) {
    const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;';
    const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------';
    const p = new RegExp(a.split('').join('|'), 'g');
  
    return string
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with ‘and’
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }
  
  const checkStorageForBasketData = () => {
    degrees = localStorage.getItem('basketFinderInputAngle');
    topSize = localStorage.getItem('basketFinderInputTop');
    bottomType = localStorage.getItem('basketFinderInputBottomType');
  
    if (degrees != null && degrees != undefined) {
      degrees = slugify(degrees);
      let degreesVal = degrees.replace('-', '°-');
      degreesVal = degreesVal + '°';
      $(`.js-basket-finder-input-angle-btn[value=${degreesVal}]`).addClass('border-grey-300');
    } else {
      degrees = '';
    }
  
    if (topSize != null) {
      topSize = slugify(topSize);
      $('.js-basket-finder-input-top').val(topSize);
    } else {
      topSize = '';
    }
  
    if (bottomType != null) {
      bottomType = slugify(bottomType);
      $(`.js-basket-finder-input-bottom-type[data-bottom-type=${bottomType}]`)
        .addClass('border-grey-300')
        .addClass('selected');
    } else {
      bottomType = '';
    }
  };
  
  checkStorageForBasketData();
  
  function searchForBasket(degreesIn = degrees, topSizeIn = topSize, bottomTypeIn = bottomType) {
    $('.js-basket-search-results').html('<h2>Searching</h2>');
    degreesIn = slugify(degreesIn);
    bottomTypeIn = slugify(bottomTypeIn);
  
    const getJSONUrl = `/basket-search-results/${degreesIn}/${topSizeIn}/${bottomTypeIn}`;
  
    $('.js-basket-search-results').html('Searching…');
  
    $.ajax({
      type: 'GET',
      url: getJSONUrl,
      dataType: 'json',
      cache: false,
      success: function(json) {
        $('.js-basket-search-results').html('<h2>Results</h2>');
  
        if (json.results == undefined) {
          $.each(json, function(index) {
            let bottomTypes = '';
            this.bottomTypes.forEach(item => {
              bottomTypes += `${item},`;
            });
  
            bottomTypes = bottomTypes.replace(/\,$/, '');
  
            const resultsMessage = `
            <div class="flex justify-center text-left max-w-50 mx-auto items-center">
            <div class="w-1/2 pr-2 flex">
            <div class="w-15 ml-auto">
            <div class="aspect-ratio aspect-ratio--bottom">
              <img src="${this.basketCategoriesIllustration}" alt="${this.basketCategories}"/>
            </div>
            </div>
            </div>
            <div class="w-1/2 my-auto">
            <h2 class="w-full">
              ${this.basketCategories}
            </h2>
            <a class="js-add-to-order-btn btn btn--sm btn--blue"
            data-basket-categories="${this.basketCategories}"
            data-bottom-types="${bottomTypes}"
            data-burlap-liner="${this.burlapLiner}"
            data-burlap-square="${this.burlapSquare}"
            data-pallet-count-heavy="${this.palletCountHeavy}"
            data-pallet-count-light="${this.palletCountLight}"
            data-pallet-count-standard="${this.palletCountStandard}"
            data-rowid="row-${index}"
            data-top-size="${this.top}"
            data-taper="${this.taper}"
            href="#">Add</a>
            </div>
            </div>
            `;
  
            if (index == 'item1') {
              $('.js-basket-search-results').html('<p class="mb-0">These baskets should be a good fit for you:</p>');
            } else {
            }
            $('.js-basket-search-results').append(resultsMessage);
          });
        } else {
          let resultsMessage = `
                  <h2>No Results for:</h2>
                  <p>${degreesIn}, ${topSizeIn}, ${bottomTypeIn}</p>
                  <p><a class="link" href="#basket-search">Search Again</a></p>
                  <p><a class="link" href="/wire-baskets">View all baskets</a></p>
                  `;
          $('.js-basket-search-results').html(resultsMessage);
        }
      },
      error: function(request, status, error) {
        $('.js-basket-search-results').html(`
              <h2>Something went wrong 😭</h2>
              <p><a class="link" href="#basket-search">Search Again</a></p>
              <p><a class="link" href="/wire-baskets">View all baskets</a></p>
              `);
      }
    });
  }
  
  $('.js-basket-finder-input-angle-btn').on('click', function(e) {
    degrees = $(this).val();
    localStorage.setItem('basketFinderInputAngle', degrees);
    $('.js-basket-finder-input-angle-btn').removeClass('border-grey-300');
    $(this).addClass('border-grey-300');
  
    $('html, body').animate(
      {
        scrollTop: $('#top-size').offset().top
      },
      1000
    );
  
    return false;
  });
  
  $('.js-basket-finder-input-top').on('change', function(e) {
    topSize = this.value;
    localStorage.setItem('basketFinderInputTop', topSize);
  
    $('html, body').animate(
      {
        scrollTop: $('#bottom-type').offset().top
      },
      1000
    );
  
    return false;
  });
  
  $('.js-basket-finder-input-bottom-type').on('click', function(e) {
    bottomType = $(this).data('bottom-type');
    localStorage.setItem('basketFinderInputBottomType', bottomType);
    $('.js-basket-finder-input-bottom-type').removeClass('border-grey-300');
    $(this).addClass('selected');
    $(this).addClass('border-grey-300');
  
    $('html, body').animate(
      {
        scrollTop: $('#search').offset().top
      },
      1000
    );
  
    return false;
  });
  
  $('.js-run-basket-search').on('click', function(e) {
    e.preventDefault;
    searchForBasket(degrees, topSize, bottomType);
  
    $('html, body').animate(
      {
        scrollTop: $('#results').offset().top
      },
      1000
    );
  
    return false;
  });
  
  $('.js-basket-search-results').on('click', 'a[href="#basket-search"]', function() {
    $('html, body').animate(
      {
        scrollTop: $('#basket-search').offset().top
      },
      1000
    );
  });
  
});

var observer = lozad('.lozad', {
  // rootMargin: '100px 0px', // like css margin
  // threshold: 0.1 // ratio of element convergence
  loaded: function(el) {
    // Custom implementation on a loaded element
    el.classList.add('loaded');
  }
});
observer.observe();

